import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import HeadComponent from '../../../HeadComponent';
import { withTemplate } from '../../../template/withTemplate';
import { PrimaryTemplate } from '../../../template/PrimaryTemplate';
import DownloadBillFormComponent from './DownloadBillFormComponent';

import { EbonBillContainer } from './DownloadEbonBillPageStyle.js';

const DownloadEbonBillPage = ({ i18n, orderId, email, hmac }) => {
    return (
        <EbonBillContainer className="conteneur conteneur-mobile" id="p-bill">
            <HeadComponent title={i18n.BILL.TITLE} description={i18n.DESCRIPTION} />
            <h1>{i18n.BILL.TITLE}</h1>

            <DownloadBillFormComponent orderId={orderId} email={email} hmac={hmac} />
        </EbonBillContainer>
    );
};

const mapStateToProps = state => {
    const locationParsed = queryString.parse(window.location.search);

    return {
        i18n: state.i18n.page.EBON,
        orderId: locationParsed.orderId,
        email: locationParsed.email,
        hmac: locationParsed.hmac
    };
};

export default withTemplate(connect(mapStateToProps)(DownloadEbonBillPage), PrimaryTemplate, {
    hideBreadcrumb: true
});



// WEBPACK FOOTER //
// ./src/components/pages/ebon/bill/DownloadEbonBillPage.js